import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  link: {
    color: theme.palette.primary.main,
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

/**
 * @name ProductNumberCell
 * @param {Object} productNumber A productNumber string
 * @param {Object} row A react-table row object
 * @return {React.Component} A date component
 */
function ProductNumberCell({ productNumber, row }) {
  const classes = useStyles();

  const { productConfiguration = {} } = row.original;

  return (
    <Link
      to={`/products/${productConfiguration.productId}`}
      className={classes.link}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      {productNumber}
    </Link>
  );
}

ProductNumberCell.propTypes = {
  productNumber: PropTypes.string.isRequired,
  row: PropTypes.object.isRequired,
};

export default ProductNumberCell;
